import Cookies, { CookieAttributes } from 'js-cookie';

import { cookieName } from '@configs/variables';

export const getCookie = (name: string, defaultValue?: string): string | undefined => {
  return Cookies.get(name) || defaultValue;
};

export const setCookie = (name: string, value: string, options?: CookieAttributes): void => {
  Cookies.set(name, value, options || {});
};

export const deleteCookie = (name: string): void => {
  Cookies.remove(name);
};

export const getAccessToken = (): string | undefined => {
  const cookie = getCookie(cookieName || '');
  return cookie;
};
